import { Observable } from 'rxjs';

import { CloudStorage } from '../models/cloud-storage.model';
import { Progress } from '../models/progress.model';

export abstract class CloudStorageGateway {
  abstract upload(storage: CloudStorage, body: Blob): Observable<Progress>;
}
